import { translate } from '../../../common/helpers/translate.helper';
import { IconSearch } from '../../../common/icons/cdl/Search';
import { Box } from '../../../common/ui/Box';
import { StatePlaceholder } from '../../StatePlaceholder/StatePlaceholder';

export const NoFilterResults = () => {
    return (
        <Box marginTop="124px" display="flex" justifyContent="center">
            <StatePlaceholder
                title={translate('global.emptyFilterResult.noMatchingResults')}
                description={translate('global.emptyFilterResult.tryDifferentFilter')}
                Icon={IconSearch}
            />
        </Box>
    );
};
